export const getCityFromSlug = (slugCity) => {
    const city = slugCity.replace(/-/g, " ")
    return city
}
